const KEY = 'swchat.release-reload';

/** Lỗi nạp chunk lười do bản phát hành mới đã thay file có hash. */
export const isStaleChunkError = (e: unknown) =>
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(String((e as Error)?.message ?? e));

/** Tải lại để lấy bản mới; chỉ một lần trong 1 phút để không lặp vô hạn khi lỗi thật. Trả về true nếu đã tải lại. */
export function reloadForNewRelease(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
